var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelalogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 850.39 850.39"
    },
    viewBox: "0 0 850.39 850.39",
    y: "0px",
    x: "0px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6D6E71;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{display:none;}\n\t.st7{display:inline;opacity:0.5;fill:#6D6E71;}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st16{fill:url(#SVGID_12_);}\n\t.st17{fill:url(#SVGID_13_);}\n\t.st18{fill:url(#SVGID_14_);}\n\t.st19{fill:url(#SVGID_15_);}\n\t.st20{fill:url(#SVGID_16_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 440.1048,
    x2: 943.3979,
    y1: 419.7439,
    x1: 6.7989,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#12C781"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#63E9DA"
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#09A9CB"
    },
    offset: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.53,426.07c-0.1-55.82,9.02-108.92,25.44-157.04h-0.03c3.04-6.98,4.75-14.67,4.75-22.76 c0-31.51-25.54-57.05-57.05-57.05c-31.51,0-57.04,25.54-57.04,57.05c0,8.1,1.71,15.79,4.75,22.76h-0.01 c16.25,47.6,25.33,100.09,25.42,155.3c0.09,55.83-9.03,108.92-25.44,157.05h0.03c-3.04,6.97-4.75,14.66-4.75,22.75 c-0.01,31.51,25.53,57.05,57.04,57.05c31.5,0,57.05-25.54,57.05-57.05c0-8.09-1.71-15.78-4.75-22.75 C293.71,533.77,284.63,481.29,284.53,426.07z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 443.7531,
    x2: 943.3186,
    y1: 423.3922,
    x1: 6.7196,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#12C781"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#63E9DA"
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#09A9CB"
    },
    offset: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.58,368.15c-31.5,0-57.04,25.55-57.04,57.05c0,31.5,25.54,57.05,57.04,57.04 c31.5,0,57.05-25.54,57.05-57.04S121.08,368.15,89.58,368.15z",
    className: "st2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 432.8231,
    x2: 943.5562,
    y1: 412.4622,
    x1: 6.9572,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#12C781"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#63E9DA"
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#09A9CB"
    },
    offset: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M592.75,189.21c-31.51,0-57.05,25.54-57.05,57.05c0,8.1,1.71,15.79,4.75,22.76h-0.03 c16.42,48.12,25.54,101.22,25.44,157.04c-0.09,55.22-9.17,107.7-25.41,155.31c-3.04,6.97-4.75,14.66-4.75,22.76 c0,31.51,25.55,57.05,57.05,57.05c31.51,0,57.05-25.54,57.04-57.05c0-8.09-1.71-15.78-4.75-22.75h0.03 c-16.41-48.13-25.53-101.22-25.44-157.05c0.09-55.22,9.17-107.7,25.42-155.3h-0.01c3.04-6.98,4.75-14.67,4.75-22.76 C649.79,214.75,624.26,189.21,592.75,189.21z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 436.4792,
    x2: 943.4767,
    y1: 416.1184,
    x1: 6.8777,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#12C781"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#63E9DA"
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#09A9CB"
    },
    offset: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477.01,505.96c-0.1-0.14-0.2-0.29-0.29-0.44c-2.79-6.21-6.63-11.83-11.33-16.62 c-13.82-20.18-27.53-41.74-27.45-64.16c0.07-22.02,13.61-43.21,27.25-63.05c4.82-4.86,8.74-10.6,11.57-16.94 c0.07-0.11,0.16-0.23,0.23-0.34h-0.06c3.07-7.01,4.81-14.74,4.81-22.88c0-31.5-25.53-57.05-57.04-57.05 c-31.5,0-57.05,25.54-57.05,57.05c0,8.14,1.73,15.87,4.81,22.88h-0.09c0.11,0.16,0.22,0.33,0.33,0.49 c2.78,6.17,6.59,11.76,11.26,16.52c13.83,20.2,27.57,41.77,27.5,64.21c-0.08,22.03-13.62,43.22-27.27,63.06 c-4.81,4.85-8.72,10.57-11.54,16.88c-0.08,0.13-0.17,0.25-0.25,0.38h0.07c-3.08,7.01-4.81,14.74-4.81,22.89 c0,31.51,25.54,57.05,57.05,57.05c31.51,0,57.05-25.54,57.05-57.05c0-8.15-1.74-15.88-4.81-22.89H477.01z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 429.1677,
    x2: 943.6357,
    y1: 408.8069,
    x1: 7.0366,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#12C781"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#63E9DA"
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#09A9CB"
    },
    offset: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M760.82,368.15c-31.5,0-57.06,25.55-57.06,57.05s25.55,57.04,57.06,57.04c31.5,0.01,57.04-25.54,57.04-57.04 C817.86,393.7,792.32,368.15,760.82,368.15z",
    className: "st5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelalogo);
export default __webpack_public_path__ + "static/media/helalogo.52d8ddc96f9acdd7d869f6ccdda503d1.svg";
export { ForwardRef as ReactComponent };